import { Stack, Tooltip } from "@mui/material";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import type { PropsWithChildren } from "react";

export function DataGridTooltipWrapper({ children, tooltip }: PropsWithChildren<{ tooltip: string | undefined }>) {
  if (tooltip) {
    return (
      <Stack direction="row" useFlexGap spacing={0.5} sx={{ alignItems: "center" }}>
        {children}
        <Tooltip title={tooltip} arrow disableInteractive>
          <HelpOutlineOutlinedIcon
            sx={(theme) => ({ fontSize: theme.spacing(2), color: theme.palette.secondary.light, cursor: "pointer" })}
          />
        </Tooltip>
      </Stack>
    );
  }
  return <>{children}</>;
}
